import React from "react";
import { connect } from "react-redux";

import {
  selectAllOwnerTypes, selectAllPercentagesRaised, selectOwnerType, selectPercentageRaised,
} from "./redux";

import { fetchResults } from "../Results/redux";

import AdvancedFilters from "./AdvancedFilters";

function AdvancedFiltersContainer({
  onOwnerTypeSelect,
  onOwnerTypeSelectAll,
  selectedOwnerType,
  onPercentageRaisedSelect,
  onPercentageRaisedSelectAll,
  selectedPercentageRaised,
}) {
  return (
    <AdvancedFilters
      onOwnerTypeSelect={onOwnerTypeSelect}
      onOwnerTypeSelectAll={onOwnerTypeSelectAll}
      selectedOwnerType={selectedOwnerType}
      onPercentageRaisedSelect={onPercentageRaisedSelect}
      onPercentageRaisedSelectAll={onPercentageRaisedSelectAll}
      selectedPercentageRaised={selectedPercentageRaised}
    />
  );
}

export default connect(
  (state) => {
    const {
      advancedFilters: {
        selectedOwnerType,
        selectedPercentageRaised,
      },
    } = state;
    return {
      selectedOwnerType,
      selectedPercentageRaised,
    };
  },
  (dispatch) => ({
    onOwnerTypeSelect: (ownerType) => {
      dispatch(selectOwnerType(ownerType));
      dispatch(fetchResults());
    },
    onOwnerTypeSelectAll: () => {
      dispatch(selectAllOwnerTypes());
      dispatch(fetchResults());
    },
    onPercentageRaisedSelect: (percentageRaised) => {
      dispatch(selectPercentageRaised(percentageRaised));
      dispatch(fetchResults());
    },
    onPercentageRaisedSelectAll: () => {
      dispatch(selectAllPercentagesRaised());
      dispatch(fetchResults());
    },
  }),
)(AdvancedFiltersContainer);
